<template>
    <div>
        <table class="table table-responsive-sm table-striped col-10">
            <tbody>
            <tr v-for="tag in tags" :key="tag.id">
              <td>
                <div style="width: 150px !important;">
                  <input class="form-control-sm input-nvx text-center" v-model="tag.label">
                </div>
              </td>
              <td style="width:120px;">
                <div v-if="tag.devices.length <= 1">{{ tag.devices.length }} tracker</div>
                <div v-else>{{ tag.devices.length }} trackers</div>
              </td>
              <td>
                <div v-if="devices_ids">
                  <multiselect
                      :value="tag.devices"
                      :options="devices_options"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :hide-selected="true"
                      :preserve-search="true"
                      :placeholder="$t('select_visibles_devices')"
                      :select-label="$t('select')"
                      :selected-label="$t('selected')"
                      :deselect-label="$t('deselect_label')"
                      :custom-label="device_label"
                      @select="add_device_to_tag(tag, $event)"
                      @remove="remove_device_from_tag(tag, $event)"
                  >
                  </multiselect>
                </div>
              </td>
              <td>
                <div class="btn-group">
                  <button class="btn btn-sm btn-primary"
                          v-on:click="save(tag)">{{$t('Save')}}
                  </button>
                  <button class="btn btn-sm btn-danger" v-on:click="will_delete(tag)">
                    {{$t('delete')}}
                  </button>
                </div>
              </td>

            </tr>
            <tr>
                <td colspan="2"><input class="form-control-sm input-nvx" :placeholder="$t('enter_label')"
                                       v-model="new_tag.label"></td>
                <td>
                    <button class="btn btn-sm btn-primary" v-on:click="add(new_tag)">{{$t('add')}}</button>
                </td>
            </tr>
            </tbody>
        </table>

        <div v-if="tag_to_delete">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">{{$t('delete_tag')}} {{tag_to_delete.label}}
                                    </h4>
                                </div>
                                <div class="modal-body">
                                    <h5>{{$t('delete_tag_definitive')}}</h5>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" @click="cancel_delete">{{$t('cancel')}}</button>
                                    <a id='delete-btn' v-on:click="on_delete(tag_to_delete)" class="btn btn-danger">{{$t('delete')}}</a>
                                </div>
                            </div><!-- /.modal-content -->
                        </div><!-- /.modal-dialog -->
                    </div><!-- /.modal -->
                </div>
            </transition>
        </div>
    </div>


</template>

<script>
    import {HTTP} from '../http-constants'
    import Multiselect from 'vue-multiselect'

    export default {
      components: {
        multiselect: Multiselect,
      },
        data() {
            return {
                devices: [],
                devices_ids: [],
                devices_options: [],
                tags: [],
                new_tag: {},
                tag_to_delete: null,
            }
        },
        methods: {
          'load': function () {
            var self = this;
            HTTP.get('/devicetags/',)
                .then(function (re) {
                  console.log("Tags", re.data);
                  self.tags = re.data;
                })
                .catch(function (error) {
                  console.log(error);
                });
          },
          'load_devices': function () {
            var self = this;
            HTTP.get('/devices/?type=tracker&sort=name',)
                .then(function (re) {
                  self.devices = re.data;
                  self.devices_ids = self.devices.map(a => a.id);

                  self.devices_options = self.devices_ids.slice();
                  self.devices_options.unshift(-1);
                  console.log("device ids", self.devices_ids);
                  console.log("device options", self.devices_options);
                  console.log('Options: ' + self.devices_options.length);
                })
                .catch(function (error) {
                  console.log(error);
                });
          },
            'save': function (tag) {
                HTTP.patch("/devicetags/" + tag.id + "/", tag)
                    .then(function (re) {
                        tag = re.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            'on_delete': function (tag) {
                var self = this;
                this.tag_to_delete = null
                HTTP.delete("/devicetags/" + tag.id + "/", tag)
                    .then(function (re) {
                        var idx = self.tags.indexOf(tag)
                        if (idx >= 0) {
                            self.tags.splice(idx, 1);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            'add': function (tag) {
                var self = this;
                if (tag.label == null) {
                    return;
                }
                HTTP.post("/devicetags/", tag)
                    .then(function (re) {
                        tag = re.data;
                        self.tags.push(Object.assign({}, tag));
                        self.new_tag = {}
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
          add_device_to_tag: function (tag, device_id) {
            console.log("Adding device to tag", tag.id, device_id);
            if (device_id < 0) {
              tag.devices = this.devices_ids.slice();
              return;
            }
            if (!tag.devices.includes(device_id)) {
              tag.devices.push(device_id);
            }
          },
          remove_device_from_tag: function (tag, device_id) {
            const index = tag.devices.indexOf(device_id);
            if (index > -1) {
              tag.devices.splice(index, 1);
            }
          },
          device_label: function (option) {

            if (option < 0) {
              return app.$t('select_all');
            }
            const device = this.devices.find(d => d.id === option);

            if (!device) {
              console.warn("Device not found for id:", option);
              return 'unknown_device';
            }
            return device.name
          },
            'will_delete': function (tag) {
                this.tag_to_delete = tag;
            },
            'cancel_delete': function(){
                this.tag_to_delete = null
            }
        },
        mounted: function () {
            this.load_devices();
            this.load();
        }
    }
</script>